module.exports = __webpack_public_path__ + "static/img/histoire-08.4c61ccc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/histoire-08.png
// module id = 93
// module chunks = 0